// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"218":"cdf50010","350":"faef5da7","453":"a1acbe7b","767":"c865a759","787":"28cb0dcd","794":"ccd353dc","877":"e6cbd9a1","922":"68afb89c","925":"1ac1971e","930":"00e10d8e","983":"f49d4147"}[chunkId] + ".chunk.js";
};